import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["effect", "style"],
  _excluded2 = ["direction", "reverse"],
  _excluded3 = ["big", "direction", "reverse"],
  _excluded4 = ["direction", "reverse", "style"],
  _excluded5 = ["style"],
  _excluded6 = ["reverse"],
  _excluded7 = ["direction", "reverse", "style"],
  _excluded8 = ["direction", "reverse"],
  _excluded9 = ["direction", "reverse"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// src/components/AttentionSeeker.tsx
import { useMemo as useMemo2 } from "react";

// src/animations/attention_seekers/bounce.ts
import { keyframes } from "@emotion/react";
var bounce = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from,\n  20%,\n  53%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(0, 0, 0);\n  }\n\n  40%,\n  43% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -30px, 0) scaleY(1.1);\n  }\n\n  70% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -15px, 0) scaleY(1.05);\n  }\n\n  80% {\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(0, 0, 0) scaleY(0.95);\n  }\n\n  90% {\n    transform: translate3d(0, -4px, 0) scaleY(1.02);\n  }\n"])));

// src/animations/attention_seekers/flash.ts
import { keyframes as keyframes2 } from "@emotion/react";
var flash = keyframes2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from,\n  50%,\n  to {\n    opacity: 1;\n  }\n\n  25%,\n  75% {\n    opacity: 0;\n  }\n"])));

// src/animations/attention_seekers/headShake.ts
import { keyframes as keyframes3 } from "@emotion/react";
var headShake = keyframes3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateX(0);\n  }\n\n  6.5% {\n    transform: translateX(-6px) rotateY(-9deg);\n  }\n\n  18.5% {\n    transform: translateX(5px) rotateY(7deg);\n  }\n\n  31.5% {\n    transform: translateX(-3px) rotateY(-5deg);\n  }\n\n  43.5% {\n    transform: translateX(2px) rotateY(3deg);\n  }\n\n  50% {\n    transform: translateX(0);\n  }\n"])));

// src/animations/attention_seekers/heartBeat.ts
import { keyframes as keyframes4 } from "@emotion/react";
var heartBeat = keyframes4(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n\n  14% {\n    transform: scale(1.3);\n  }\n\n  28% {\n    transform: scale(1);\n  }\n\n  42% {\n    transform: scale(1.3);\n  }\n\n  70% {\n    transform: scale(1);\n  }\n"])));

// src/animations/attention_seekers/jello.ts
import { keyframes as keyframes5 } from "@emotion/react";
var jello = keyframes5(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  from,\n  11.1%,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  22.2% {\n    transform: skewX(-12.5deg) skewY(-12.5deg);\n  }\n\n  33.3% {\n    transform: skewX(6.25deg) skewY(6.25deg);\n  }\n\n  44.4% {\n    transform: skewX(-3.125deg) skewY(-3.125deg);\n  }\n\n  55.5% {\n    transform: skewX(1.5625deg) skewY(1.5625deg);\n  }\n\n  66.6% {\n    transform: skewX(-0.78125deg) skewY(-0.78125deg);\n  }\n\n  77.7% {\n    transform: skewX(0.390625deg) skewY(0.390625deg);\n  }\n\n  88.8% {\n    transform: skewX(-0.1953125deg) skewY(-0.1953125deg);\n  }\n"])));

// src/animations/attention_seekers/pulse.ts
import { keyframes as keyframes6 } from "@emotion/react";
var pulse = keyframes6(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  50% {\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n"])));

// src/animations/attention_seekers/rubberBand.ts
import { keyframes as keyframes7 } from "@emotion/react";
var rubberBand = keyframes7(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  30% {\n    transform: scale3d(1.25, 0.75, 1);\n  }\n\n  40% {\n    transform: scale3d(0.75, 1.25, 1);\n  }\n\n  50% {\n    transform: scale3d(1.15, 0.85, 1);\n  }\n\n  65% {\n    transform: scale3d(0.95, 1.05, 1);\n  }\n\n  75% {\n    transform: scale3d(1.05, 0.95, 1);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n"])));

// src/animations/attention_seekers/shake.ts
import { keyframes as keyframes8 } from "@emotion/react";
var shake = keyframes8(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  from,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translate3d(10px, 0, 0);\n  }\n"])));

// src/animations/attention_seekers/shakeX.ts
import { keyframes as keyframes9 } from "@emotion/react";
var shakeX = keyframes9(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  from,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translate3d(10px, 0, 0);\n  }\n"])));

// src/animations/attention_seekers/shakeY.ts
import { keyframes as keyframes10 } from "@emotion/react";
var shakeY = keyframes10(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  from,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translate3d(0, -10px, 0);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translate3d(0, 10px, 0);\n  }\n"])));

// src/animations/attention_seekers/swing.ts
import { keyframes as keyframes11 } from "@emotion/react";
var swing = keyframes11(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  20% {\n    transform: rotate3d(0, 0, 1, 15deg);\n  }\n\n  40% {\n    transform: rotate3d(0, 0, 1, -10deg);\n  }\n\n  60% {\n    transform: rotate3d(0, 0, 1, 5deg);\n  }\n\n  80% {\n    transform: rotate3d(0, 0, 1, -5deg);\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n"])));

// src/animations/attention_seekers/tada.ts
import { keyframes as keyframes12 } from "@emotion/react";
var tada = keyframes12(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  10%,\n  20% {\n    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);\n  }\n\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n  }\n\n  40%,\n  60%,\n  80% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n"])));

// src/animations/attention_seekers/wobble.ts
import { keyframes as keyframes13 } from "@emotion/react";
var wobble = keyframes13(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  15% {\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n  }\n\n  30% {\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n  }\n\n  45% {\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n  }\n\n  60% {\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n  }\n\n  75% {\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/Reveal.tsx
import { ClassNames } from "@emotion/react";
import { Children, isValidElement, useMemo } from "react";
import { InView, useInView } from "react-intersection-observer";
import { isFragment } from "react-is";

// src/animations/fading_entrances/fadeIn.ts
import { keyframes as keyframes14 } from "@emotion/react";
var fadeIn = keyframes14(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"])));

// src/animations/fading_entrances/fadeInBottomLeft.ts
import { keyframes as keyframes15 } from "@emotion/react";
var fadeInBottomLeft = keyframes15(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/fading_entrances/fadeInBottomRight.ts
import { keyframes as keyframes16 } from "@emotion/react";
var fadeInBottomRight = keyframes16(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(100%, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/fading_entrances/fadeInDown.ts
import { keyframes as keyframes17 } from "@emotion/react";
var fadeInDown = keyframes17(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/fading_entrances/fadeInDownBig.ts
import { keyframes as keyframes18 } from "@emotion/react";
var fadeInDownBig = keyframes18(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/fading_entrances/fadeInLeft.ts
import { keyframes as keyframes19 } from "@emotion/react";
var fadeInLeft = keyframes19(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/fading_entrances/fadeInLeftBig.ts
import { keyframes as keyframes20 } from "@emotion/react";
var fadeInLeftBig = keyframes20(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/fading_entrances/fadeInRight.ts
import { keyframes as keyframes21 } from "@emotion/react";
var fadeInRight = keyframes21(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/fading_entrances/fadeInRightBig.ts
import { keyframes as keyframes22 } from "@emotion/react";
var fadeInRightBig = keyframes22(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/fading_entrances/fadeInTopLeft.ts
import { keyframes as keyframes23 } from "@emotion/react";
var fadeInTopLeft = keyframes23(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/fading_entrances/fadeInTopRight.ts
import { keyframes as keyframes24 } from "@emotion/react";
var fadeInTopRight = keyframes24(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(100%, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/fading_entrances/fadeInUp.ts
import { keyframes as keyframes25 } from "@emotion/react";
var fadeInUp = keyframes25(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/fading_entrances/fadeInUpBig.ts
import { keyframes as keyframes26 } from "@emotion/react";
var fadeInUpBig = keyframes26(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/utils/animations.ts
import { css } from "@emotion/react";
function getAnimationCss(_ref) {
  var _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 1e3 : _ref$duration,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    _ref$timingFunction = _ref.timingFunction,
    timingFunction = _ref$timingFunction === void 0 ? "ease" : _ref$timingFunction,
    _ref$keyframes = _ref.keyframes,
    keyframes87 = _ref$keyframes === void 0 ? fadeInLeft : _ref$keyframes,
    _ref$iterationCount = _ref.iterationCount,
    iterationCount = _ref$iterationCount === void 0 ? 1 : _ref$iterationCount;
  return css(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    animation-duration: ", "ms;\n    animation-timing-function: ", ";\n    animation-delay: ", "ms;\n    animation-name: ", ";\n    animation-direction: normal;\n    animation-fill-mode: both;\n    animation-iteration-count: ", ";\n\n    @media (prefers-reduced-motion: reduce) {\n      animation: none;\n    }\n  "])), duration, timingFunction, delay, keyframes87, iterationCount);
}

// src/utils/guards.ts
function isNullable(a) {
  return a == void 0;
}
function isStringLike(value) {
  return typeof value === "string" || typeof value === "number" || typeof value === "boolean";
}

// src/utils/patterns.ts
function matchIf(onTrue, onFalse) {
  return function (condition) {
    return condition ? onTrue() : onFalse();
  };
}
function matchIfOrNull(onTrue) {
  return matchIf(onTrue, function () {
    return null;
  });
}

// src/Reveal.tsx
import { Fragment, jsx } from "@emotion/react/jsx-runtime";
var Reveal = function Reveal(props) {
  var _props$cascade = props.cascade,
    cascade = _props$cascade === void 0 ? false : _props$cascade,
    _props$damping = props.damping,
    damping = _props$damping === void 0 ? 0.5 : _props$damping,
    _props$delay = props.delay,
    delay = _props$delay === void 0 ? 0 : _props$delay,
    _props$duration = props.duration,
    duration = _props$duration === void 0 ? 1e3 : _props$duration,
    _props$fraction = props.fraction,
    fraction = _props$fraction === void 0 ? 0 : _props$fraction,
    _props$keyframes = props.keyframes,
    keyframes87 = _props$keyframes === void 0 ? fadeInLeft : _props$keyframes,
    _props$triggerOnce = props.triggerOnce,
    triggerOnce = _props$triggerOnce === void 0 ? false : _props$triggerOnce,
    className = props.className,
    style = props.style,
    childClassName = props.childClassName,
    childStyle = props.childStyle,
    children = props.children,
    onVisibilityChange = props.onVisibilityChange;
  var animationStyles = useMemo(function () {
    return getAnimationCss({
      keyframes: keyframes87,
      duration: duration
    });
  }, [duration, keyframes87]);
  if (isNullable(children)) return null;
  if (isStringLike(children)) return /* @__PURE__ */jsx(TextReveal, _objectSpread(_objectSpread({}, props), {}, {
    animationStyles: animationStyles,
    children: String(children)
  }));
  if (isFragment(children)) return /* @__PURE__ */jsx(FragmentReveal, _objectSpread(_objectSpread({}, props), {}, {
    animationStyles: animationStyles
  }));
  return /* @__PURE__ */jsx(Fragment, {
    children: Children.map(children, function (node, index) {
      if (!isValidElement(node)) return null;
      var nodeDelay = delay + (cascade ? index * duration * damping : 0);
      switch (node.type) {
        case "ol":
        case "ul":
          return /* @__PURE__ */jsx(ClassNames, {
            children: function children(_ref2) {
              var cx = _ref2.cx;
              return /* @__PURE__ */jsx(node.type, _objectSpread(_objectSpread({}, node.props), {}, {
                className: cx(className, node.props.className),
                style: Object.assign({}, style, node.props.style),
                children: /* @__PURE__ */jsx(Reveal, _objectSpread(_objectSpread({}, props), {}, {
                  children: node.props.children
                }))
              }));
            }
          });
        case "li":
          return /* @__PURE__ */jsx(InView, {
            threshold: fraction,
            triggerOnce: triggerOnce,
            onChange: onVisibilityChange,
            children: function children(_ref3) {
              var inView = _ref3.inView,
                ref = _ref3.ref;
              return /* @__PURE__ */jsx(ClassNames, {
                children: function children(_ref4) {
                  var cx = _ref4.cx;
                  return /* @__PURE__ */jsx(node.type, _objectSpread(_objectSpread({}, node.props), {}, {
                    ref: ref,
                    className: cx(childClassName, node.props.className),
                    css: matchIfOrNull(function () {
                      return animationStyles;
                    })(inView),
                    style: Object.assign({}, childStyle, node.props.style, {
                      animationDelay: nodeDelay + "ms"
                    })
                  }));
                }
              });
            }
          });
        default:
          return /* @__PURE__ */jsx(InView, {
            threshold: fraction,
            triggerOnce: triggerOnce,
            onChange: onVisibilityChange,
            children: function children(_ref5) {
              var inView = _ref5.inView,
                ref = _ref5.ref;
              return /* @__PURE__ */jsx("div", {
                ref: ref,
                className: className,
                css: matchIfOrNull(function () {
                  return animationStyles;
                })(inView),
                style: Object.assign({}, style, {
                  animationDelay: nodeDelay + "ms"
                }),
                children: /* @__PURE__ */jsx(ClassNames, {
                  children: function children(_ref6) {
                    var cx = _ref6.cx;
                    return /* @__PURE__ */jsx(node.type, _objectSpread(_objectSpread({}, node.props), {}, {
                      className: cx(childClassName, node.props.className),
                      style: Object.assign({}, childStyle, node.props.style)
                    }));
                  }
                })
              });
            }
          });
      }
    })
  });
};
var textBaseStyles = {
  display: "inline-block",
  whiteSpace: "pre"
};
var TextReveal = function TextReveal(props) {
  var animationStyles = props.animationStyles,
    _props$cascade2 = props.cascade,
    cascade = _props$cascade2 === void 0 ? false : _props$cascade2,
    _props$damping2 = props.damping,
    damping = _props$damping2 === void 0 ? 0.5 : _props$damping2,
    _props$delay2 = props.delay,
    delay = _props$delay2 === void 0 ? 0 : _props$delay2,
    _props$duration2 = props.duration,
    duration = _props$duration2 === void 0 ? 1e3 : _props$duration2,
    _props$fraction2 = props.fraction,
    fraction = _props$fraction2 === void 0 ? 0 : _props$fraction2,
    _props$triggerOnce2 = props.triggerOnce,
    triggerOnce = _props$triggerOnce2 === void 0 ? false : _props$triggerOnce2,
    className = props.className,
    style = props.style,
    children = props.children,
    onVisibilityChange = props.onVisibilityChange;
  var _useInView = useInView({
      triggerOnce: triggerOnce,
      threshold: fraction,
      onChange: onVisibilityChange
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  return matchIf(function () {
    return /* @__PURE__ */jsx("div", {
      ref: ref,
      className: className,
      style: Object.assign({}, style, textBaseStyles),
      children: children.split("").map(function (char, index) {
        return /* @__PURE__ */jsx("span", {
          css: matchIfOrNull(function () {
            return animationStyles;
          })(inView),
          style: {
            animationDelay: delay + index * duration * damping + "ms"
          },
          children: char
        }, index);
      })
    });
  }, function () {
    return /* @__PURE__ */jsx(FragmentReveal, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }));
  })(cascade);
};
var FragmentReveal = function FragmentReveal(props) {
  var animationStyles = props.animationStyles,
    _props$fraction3 = props.fraction,
    fraction = _props$fraction3 === void 0 ? 0 : _props$fraction3,
    _props$triggerOnce3 = props.triggerOnce,
    triggerOnce = _props$triggerOnce3 === void 0 ? false : _props$triggerOnce3,
    className = props.className,
    style = props.style,
    children = props.children,
    onVisibilityChange = props.onVisibilityChange;
  var _useInView2 = useInView({
      triggerOnce: triggerOnce,
      threshold: fraction,
      onChange: onVisibilityChange
    }),
    ref = _useInView2.ref,
    inView = _useInView2.inView;
  return /* @__PURE__ */jsx("div", {
    ref: ref,
    className: className,
    css: matchIfOrNull(function () {
      return animationStyles;
    })(inView),
    style: style,
    children: children
  });
};

// src/components/AttentionSeeker.tsx
import { jsx as jsx2 } from "@emotion/react/jsx-runtime";
function getStyles(effect) {
  switch (effect) {
    case "bounce":
      return [bounce, {
        transformOrigin: "center bottom"
      }];
    case "flash":
      return [flash];
    case "headShake":
      return [headShake, {
        animationTimingFunction: "ease-in-out"
      }];
    case "heartBeat":
      return [heartBeat, {
        animationTimingFunction: "ease-in-out"
      }];
    case "jello":
      return [jello, {
        transformOrigin: "center"
      }];
    case "pulse":
      return [pulse, {
        animationTimingFunction: "ease-in-out"
      }];
    case "rubberBand":
      return [rubberBand];
    case "shake":
      return [shake];
    case "shakeX":
      return [shakeX];
    case "shakeY":
      return [shakeY];
    case "swing":
      return [swing, {
        transformOrigin: "top center"
      }];
    case "tada":
      return [tada];
    case "wobble":
      return [wobble];
  }
}
var AttentionSeeker = function AttentionSeeker(props) {
  var _props$effect = props.effect,
    effect = _props$effect === void 0 ? "bounce" : _props$effect,
    style = props.style,
    rest = _objectWithoutProperties(props, _excluded);
  var _useMemo = useMemo2(function () {
      return getStyles(effect);
    }, [effect]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    keyframes87 = _useMemo2[0],
    animationCss3 = _useMemo2[1];
  return /* @__PURE__ */jsx2(Reveal, _objectSpread({
    keyframes: keyframes87,
    style: Object.assign({}, style, animationCss3)
  }, rest));
};

// src/components/Bounce.tsx
import { useMemo as useMemo3 } from "react";

// src/animations/bouncing_entrances/bounceIn.ts
import { keyframes as keyframes27 } from "@emotion/react";
var bounceIn = keyframes27(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  from,\n  20%,\n  40%,\n  60%,\n  80%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  20% {\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  40% {\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n\n  80% {\n    transform: scale3d(0.97, 0.97, 0.97);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n  }\n"])));

// src/animations/bouncing_entrances/bounceInDown.ts
import { keyframes as keyframes28 } from "@emotion/react";
var bounceInDown = keyframes28(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0) scaleY(3);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0) scaleY(0.9);\n  }\n\n  75% {\n    transform: translate3d(0, -10px, 0) scaleY(0.95);\n  }\n\n  90% {\n    transform: translate3d(0, 5px, 0) scaleY(0.985);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/bouncing_entrances/bounceInLeft.ts
import { keyframes as keyframes29 } from "@emotion/react";
var bounceInLeft = keyframes29(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0) scaleX(3);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0) scaleX(1);\n  }\n\n  75% {\n    transform: translate3d(-10px, 0, 0) scaleX(0.98);\n  }\n\n  90% {\n    transform: translate3d(5px, 0, 0) scaleX(0.995);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/bouncing_entrances/bounceInRight.ts
import { keyframes as keyframes30 } from "@emotion/react";
var bounceInRight = keyframes30(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0) scaleX(3);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0) scaleX(1);\n  }\n\n  75% {\n    transform: translate3d(10px, 0, 0) scaleX(0.98);\n  }\n\n  90% {\n    transform: translate3d(-5px, 0, 0) scaleX(0.995);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/bouncing_entrances/bounceInUp.ts
import { keyframes as keyframes31 } from "@emotion/react";
var bounceInUp = keyframes31(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0) scaleY(5);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0) scaleY(0.9);\n  }\n\n  75% {\n    transform: translate3d(0, 10px, 0) scaleY(0.95);\n  }\n\n  90% {\n    transform: translate3d(0, -5px, 0) scaleY(0.985);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/bouncing_exits/bounceOut.ts
import { keyframes as keyframes32 } from "@emotion/react";
var bounceOut = keyframes32(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  20% {\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  50%,\n  55% {\n    opacity: 1;\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n"])));

// src/animations/bouncing_exits/bounceOutDown.ts
import { keyframes as keyframes33 } from "@emotion/react";
var bounceOutDown = keyframes33(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  20% {\n    transform: translate3d(0, 10px, 0) scaleY(0.985);\n  }\n\n  40%,\n  45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0) scaleY(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0) scaleY(3);\n  }\n"])));

// src/animations/bouncing_exits/bounceOutLeft.ts
import { keyframes as keyframes34 } from "@emotion/react";
var bounceOutLeft = keyframes34(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0) scaleX(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0) scaleX(2);\n  }\n"])));

// src/animations/bouncing_exits/bounceOutRight.ts
import { keyframes as keyframes35 } from "@emotion/react";
var bounceOutRight = keyframes35(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0) scaleX(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0) scaleX(2);\n  }\n"])));

// src/animations/bouncing_exits/bounceOutUp.ts
import { keyframes as keyframes36 } from "@emotion/react";
var bounceOutUp = keyframes36(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  20% {\n    transform: translate3d(0, -10px, 0) scaleY(0.985);\n  }\n\n  40%,\n  45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0) scaleY(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0) scaleY(3);\n  }\n"])));

// src/components/Bounce.tsx
import { jsx as jsx3 } from "@emotion/react/jsx-runtime";
function getStyles2(reverse, direction) {
  switch (direction) {
    case "down":
      return reverse ? bounceOutDown : bounceInDown;
    case "left":
      return reverse ? bounceOutLeft : bounceInLeft;
    case "right":
      return reverse ? bounceOutRight : bounceInRight;
    case "up":
      return reverse ? bounceOutUp : bounceInUp;
    default:
      return reverse ? bounceOut : bounceIn;
  }
}
var Bounce = function Bounce(props) {
  var direction = props.direction,
    _props$reverse = props.reverse,
    reverse = _props$reverse === void 0 ? false : _props$reverse,
    rest = _objectWithoutProperties(props, _excluded2);
  var keyframes87 = useMemo3(function () {
    return getStyles2(reverse, direction);
  }, [direction, reverse]);
  return /* @__PURE__ */jsx3(Reveal, _objectSpread({
    keyframes: keyframes87
  }, rest));
};

// src/components/Fade.tsx
import { useMemo as useMemo4 } from "react";

// src/animations/fading_exits/fadeOut.ts
import { keyframes as keyframes37 } from "@emotion/react";
var fadeOut = keyframes37(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"])));

// src/animations/fading_exits/fadeOutBottomLeft.ts
import { keyframes as keyframes38 } from "@emotion/react";
var fadeOutBottomLeft = keyframes38(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, 100%, 0);\n  }\n"])));

// src/animations/fading_exits/fadeOutBottomRight.ts
import { keyframes as keyframes39 } from "@emotion/react";
var fadeOutBottomRight = keyframes39(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 100%, 0);\n  }\n"])));

// src/animations/fading_exits/fadeOutDown.ts
import { keyframes as keyframes40 } from "@emotion/react";
var fadeOutDown = keyframes40(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n"])));

// src/animations/fading_exits/fadeOutDownBig.ts
import { keyframes as keyframes41 } from "@emotion/react";
var fadeOutDownBig = keyframes41(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n"])));

// src/animations/fading_exits/fadeOutLeft.ts
import { keyframes as keyframes42 } from "@emotion/react";
var fadeOutLeft = keyframes42(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n"])));

// src/animations/fading_exits/fadeOutLeftBig.ts
import { keyframes as keyframes43 } from "@emotion/react";
var fadeOutLeftBig = keyframes43(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n"])));

// src/animations/fading_exits/fadeOutRight.ts
import { keyframes as keyframes44 } from "@emotion/react";
var fadeOutRight = keyframes44(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n"])));

// src/animations/fading_exits/fadeOutRightBig.ts
import { keyframes as keyframes45 } from "@emotion/react";
var fadeOutRightBig = keyframes45(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n"])));

// src/animations/fading_exits/fadeOutTopLeft.ts
import { keyframes as keyframes46 } from "@emotion/react";
var fadeOutTopLeft = keyframes46(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, -100%, 0);\n  }\n"])));

// src/animations/fading_exits/fadeOutTopRight.ts
import { keyframes as keyframes47 } from "@emotion/react";
var fadeOutTopRight = keyframes47(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, -100%, 0);\n  }\n"])));

// src/animations/fading_exits/fadeOutUp.ts
import { keyframes as keyframes48 } from "@emotion/react";
var fadeOutUp = keyframes48(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n"])));

// src/animations/fading_exits/fadeOutUpBig.ts
import { keyframes as keyframes49 } from "@emotion/react";
var fadeOutUpBig = keyframes49(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n"])));

// src/components/Fade.tsx
import { jsx as jsx4 } from "@emotion/react/jsx-runtime";
function getStyles3(big, reverse, direction) {
  switch (direction) {
    case "bottom-left":
      return reverse ? fadeOutBottomLeft : fadeInBottomLeft;
    case "bottom-right":
      return reverse ? fadeOutBottomRight : fadeInBottomRight;
    case "down":
      return big ? reverse ? fadeOutDownBig : fadeInDownBig : reverse ? fadeOutDown : fadeInDown;
    case "left":
      return big ? reverse ? fadeOutLeftBig : fadeInLeftBig : reverse ? fadeOutLeft : fadeInLeft;
    case "right":
      return big ? reverse ? fadeOutRightBig : fadeInRightBig : reverse ? fadeOutRight : fadeInRight;
    case "top-left":
      return reverse ? fadeOutTopLeft : fadeInTopLeft;
    case "top-right":
      return reverse ? fadeOutTopRight : fadeInTopRight;
    case "up":
      return big ? reverse ? fadeOutUpBig : fadeInUpBig : reverse ? fadeOutUp : fadeInUp;
    default:
      return reverse ? fadeOut : fadeIn;
  }
}
var Fade = function Fade(props) {
  var _props$big = props.big,
    big = _props$big === void 0 ? false : _props$big,
    direction = props.direction,
    _props$reverse2 = props.reverse,
    reverse = _props$reverse2 === void 0 ? false : _props$reverse2,
    rest = _objectWithoutProperties(props, _excluded3);
  var keyframes87 = useMemo4(function () {
    return getStyles3(big, reverse, direction);
  }, [big, direction, reverse]);
  return /* @__PURE__ */jsx4(Reveal, _objectSpread({
    keyframes: keyframes87
  }, rest));
};

// src/components/Flip.tsx
import { useMemo as useMemo5 } from "react";

// src/animations/flippers/flip.ts
import { keyframes as keyframes50 } from "@emotion/react";
var flip = keyframes50(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  from {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);\n    animation-timing-function: ease-out;\n  }\n\n  40% {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)\n      rotate3d(0, 1, 0, -190deg);\n    animation-timing-function: ease-out;\n  }\n\n  50% {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)\n      rotate3d(0, 1, 0, -170deg);\n    animation-timing-function: ease-in;\n  }\n\n  80% {\n    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0)\n      rotate3d(0, 1, 0, 0deg);\n    animation-timing-function: ease-in;\n  }\n\n  to {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);\n    animation-timing-function: ease-in;\n  }\n"])));

// src/animations/flippers/flipInX.ts
import { keyframes as keyframes51 } from "@emotion/react";
var flipInX = keyframes51(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1;\n  }\n\n  80% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n  }\n\n  to {\n    transform: perspective(400px);\n  }\n"])));

// src/animations/flippers/flipInY.ts
import { keyframes as keyframes52 } from "@emotion/react";
var flipInY = keyframes52(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n  from {\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n    opacity: 1;\n  }\n\n  80% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\n  }\n\n  to {\n    transform: perspective(400px);\n  }\n"])));

// src/animations/flippers/flipOutX.ts
import { keyframes as keyframes53 } from "@emotion/react";
var flipOutX = keyframes53(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n  from {\n    transform: perspective(400px);\n  }\n\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n"])));

// src/animations/flippers/flipOutY.ts
import { keyframes as keyframes54 } from "@emotion/react";
var flipOutY = keyframes54(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  from {\n    transform: perspective(400px);\n  }\n\n  30% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    opacity: 0;\n  }\n"])));

// src/components/Flip.tsx
import { jsx as jsx5 } from "@emotion/react/jsx-runtime";
function getStyles4(reverse, direction) {
  switch (direction) {
    case "horizontal":
      return reverse ? flipOutX : flipInX;
    case "vertical":
      return reverse ? flipOutY : flipInY;
    default:
      return flip;
  }
}
var animationCss = {
  backfaceVisibility: "visible"
};
var Flip = function Flip(props) {
  var direction = props.direction,
    _props$reverse3 = props.reverse,
    reverse = _props$reverse3 === void 0 ? false : _props$reverse3,
    style = props.style,
    rest = _objectWithoutProperties(props, _excluded4);
  var keyframes87 = useMemo5(function () {
    return getStyles4(reverse, direction);
  }, [direction, reverse]);
  return /* @__PURE__ */jsx5(Reveal, _objectSpread({
    keyframes: keyframes87,
    style: Object.assign({}, style, animationCss)
  }, rest));
};

// src/animations/specials/hinge.ts
import { keyframes as keyframes55 } from "@emotion/react";
var hinge = keyframes55(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n  0% {\n    animation-timing-function: ease-in-out;\n  }\n\n  20%,\n  60% {\n    transform: rotate3d(0, 0, 1, 80deg);\n    animation-timing-function: ease-in-out;\n  }\n\n  40%,\n  80% {\n    transform: rotate3d(0, 0, 1, 60deg);\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n\n  to {\n    transform: translate3d(0, 700px, 0);\n    opacity: 0;\n  }\n"])));

// src/animations/specials/jackInTheBox.ts
import { keyframes as keyframes56 } from "@emotion/react";
var jackInTheBox = keyframes56(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale(0.1) rotate(30deg);\n    transform-origin: center bottom;\n  }\n\n  50% {\n    transform: rotate(-10deg);\n  }\n\n  70% {\n    transform: rotate(3deg);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"])));

// src/animations/specials/rollIn.ts
import { keyframes as keyframes57 } from "@emotion/react";
var rollIn = keyframes57(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/specials/rollOut.ts
import { keyframes as keyframes58 } from "@emotion/react";
var rollOut = keyframes58(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\n  }\n"])));

// src/components/Hinge.tsx
import { jsx as jsx6 } from "@emotion/react/jsx-runtime";
var animationCss2 = {
  transformOrigin: "top left"
};
var Hinge = function Hinge(props) {
  var style = props.style,
    rest = _objectWithoutProperties(props, _excluded5);
  return /* @__PURE__ */jsx6(Reveal, _objectSpread({
    keyframes: hinge,
    style: Object.assign({}, style, animationCss2)
  }, rest));
};

// src/components/JackInTheBox.tsx
import { jsx as jsx7 } from "@emotion/react/jsx-runtime";
var JackInTheBox = function JackInTheBox(props) {
  return /* @__PURE__ */jsx7(Reveal, _objectSpread({
    keyframes: jackInTheBox
  }, props));
};

// src/components/Roll.tsx
import { useMemo as useMemo6 } from "react";
import { jsx as jsx8 } from "@emotion/react/jsx-runtime";
function getStyles5(reverse) {
  return reverse ? rollOut : rollIn;
}
var Roll = function Roll(props) {
  var _props$reverse4 = props.reverse,
    reverse = _props$reverse4 === void 0 ? false : _props$reverse4,
    rest = _objectWithoutProperties(props, _excluded6);
  var keyframes87 = useMemo6(function () {
    return getStyles5(reverse);
  }, [reverse]);
  return /* @__PURE__ */jsx8(Reveal, _objectSpread({
    keyframes: keyframes87
  }, rest));
};

// src/components/Rotate.tsx
import { useMemo as useMemo7 } from "react";

// src/animations/rotating_entrances/rotateIn.ts
import { keyframes as keyframes59 } from "@emotion/react";
var rotateIn = keyframes59(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"])));

// src/animations/rotating_entrances/rotateInDownLeft.ts
import { keyframes as keyframes60 } from "@emotion/react";
var rotateInDownLeft = keyframes60(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"])));

// src/animations/rotating_entrances/rotateInDownRight.ts
import { keyframes as keyframes61 } from "@emotion/react";
var rotateInDownRight = keyframes61(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"])));

// src/animations/rotating_entrances/rotateInUpLeft.ts
import { keyframes as keyframes62 } from "@emotion/react";
var rotateInUpLeft = keyframes62(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"])));

// src/animations/rotating_entrances/rotateInUpRight.ts
import { keyframes as keyframes63 } from "@emotion/react";
var rotateInUpRight = keyframes63(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate3d(0, 0, 1, -90deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"])));

// src/animations/rotating_exits/rotateOut.ts
import { keyframes as keyframes64 } from "@emotion/react";
var rotateOut = keyframes64(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 200deg);\n    opacity: 0;\n  }\n"])));

// src/animations/rotating_exits/rotateOutDownLeft.ts
import { keyframes as keyframes65 } from "@emotion/react";
var rotateOutDownLeft = keyframes65(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0;\n  }\n"])));

// src/animations/rotating_exits/rotateOutDownRight.ts
import { keyframes as keyframes66 } from "@emotion/react";
var rotateOutDownRight = keyframes66(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n"])));

// src/animations/rotating_exits/rotateOutUpLeft.ts
import { keyframes as keyframes67 } from "@emotion/react";
var rotateOutUpLeft = keyframes67(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n"])));

// src/animations/rotating_exits/rotateOutUpRight.ts
import { keyframes as keyframes68 } from "@emotion/react";
var rotateOutUpRight = keyframes68(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 90deg);\n    opacity: 0;\n  }\n"])));

// src/components/Rotate.tsx
import { jsx as jsx9 } from "@emotion/react/jsx-runtime";
function getStyles6(reverse, direction) {
  switch (direction) {
    case "bottom-left":
      return reverse ? [rotateOutDownLeft, {
        transformOrigin: "left bottom"
      }] : [rotateInDownLeft, {
        transformOrigin: "left bottom"
      }];
    case "bottom-right":
      return reverse ? [rotateOutDownRight, {
        transformOrigin: "right bottom"
      }] : [rotateInDownRight, {
        transformOrigin: "right bottom"
      }];
    case "top-left":
      return reverse ? [rotateOutUpLeft, {
        transformOrigin: "left bottom"
      }] : [rotateInUpLeft, {
        transformOrigin: "left bottom"
      }];
    case "top-right":
      return reverse ? [rotateOutUpRight, {
        transformOrigin: "right bottom"
      }] : [rotateInUpRight, {
        transformOrigin: "right bottom"
      }];
    default:
      return reverse ? [rotateOut, {
        transformOrigin: "center"
      }] : [rotateIn, {
        transformOrigin: "center"
      }];
  }
}
var Rotate = function Rotate(props) {
  var direction = props.direction,
    _props$reverse5 = props.reverse,
    reverse = _props$reverse5 === void 0 ? false : _props$reverse5,
    style = props.style,
    rest = _objectWithoutProperties(props, _excluded7);
  var _useMemo3 = useMemo7(function () {
      return getStyles6(reverse, direction);
    }, [direction, reverse]),
    _useMemo4 = _slicedToArray(_useMemo3, 2),
    keyframes87 = _useMemo4[0],
    animationCss3 = _useMemo4[1];
  return /* @__PURE__ */jsx9(Reveal, _objectSpread({
    keyframes: keyframes87,
    style: Object.assign({}, style, animationCss3)
  }, rest));
};

// src/components/Slide.tsx
import { useMemo as useMemo8 } from "react";

// src/animations/sliding_entrances/slideInDown.ts
import { keyframes as keyframes69 } from "@emotion/react";
var slideInDown = keyframes69(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/sliding_entrances/slideInLeft.ts
import { keyframes as keyframes70 } from "@emotion/react";
var slideInLeft = keyframes70(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(-100%, 0, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/sliding_entrances/slideInRight.ts
import { keyframes as keyframes71 } from "@emotion/react";
var slideInRight = keyframes71(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(100%, 0, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/sliding_entrances/slideInUp.ts
import { keyframes as keyframes72 } from "@emotion/react";
var slideInUp = keyframes72(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"])));

// src/animations/sliding_exits/slideOutDown.ts
import { keyframes as keyframes73 } from "@emotion/react";
var slideOutDown = keyframes73(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 100%, 0);\n  }\n"])));

// src/animations/sliding_exits/slideOutLeft.ts
import { keyframes as keyframes74 } from "@emotion/react";
var slideOutLeft = keyframes74(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(-100%, 0, 0);\n  }\n"])));

// src/animations/sliding_exits/slideOutRight.ts
import { keyframes as keyframes75 } from "@emotion/react";
var slideOutRight = keyframes75(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(100%, 0, 0);\n  }\n"])));

// src/animations/sliding_exits/slideOutUp.ts
import { keyframes as keyframes76 } from "@emotion/react";
var slideOutUp = keyframes76(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -100%, 0);\n  }\n"])));

// src/components/Slide.tsx
import { jsx as jsx10 } from "@emotion/react/jsx-runtime";
function getStyles7(reverse, direction) {
  switch (direction) {
    case "down":
      return reverse ? slideOutDown : slideInDown;
    case "right":
      return reverse ? slideOutRight : slideInRight;
    case "up":
      return reverse ? slideOutUp : slideInUp;
    case "left":
    default:
      return reverse ? slideOutLeft : slideInLeft;
  }
}
var Slide = function Slide(props) {
  var direction = props.direction,
    _props$reverse6 = props.reverse,
    reverse = _props$reverse6 === void 0 ? false : _props$reverse6,
    rest = _objectWithoutProperties(props, _excluded8);
  var keyframes87 = useMemo8(function () {
    return getStyles7(reverse, direction);
  }, [direction, reverse]);
  return /* @__PURE__ */jsx10(Reveal, _objectSpread({
    keyframes: keyframes87
  }, rest));
};

// src/components/Zoom.tsx
import { useMemo as useMemo9 } from "react";

// src/animations/zooming_entrances/zoomIn.ts
import { keyframes as keyframes77 } from "@emotion/react";
var zoomIn = keyframes77(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  50% {\n    opacity: 1;\n  }\n"])));

// src/animations/zooming_entrances/zoomInDown.ts
import { keyframes as keyframes78 } from "@emotion/react";
var zoomInDown = keyframes78(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));

// src/animations/zooming_entrances/zoomInLeft.ts
import { keyframes as keyframes79 } from "@emotion/react";
var zoomInLeft = keyframes79(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));

// src/animations/zooming_entrances/zoomInRight.ts
import { keyframes as keyframes80 } from "@emotion/react";
var zoomInRight = keyframes80(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));

// src/animations/zooming_entrances/zoomInUp.ts
import { keyframes as keyframes81 } from "@emotion/react";
var zoomInUp = keyframes81(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));

// src/animations/zooming_exits/zoomOut.ts
import { keyframes as keyframes82 } from "@emotion/react";
var zoomOut = keyframes82(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  to {\n    opacity: 0;\n  }\n"])));

// src/animations/zooming_exits/zoomOutDown.ts
import { keyframes as keyframes83 } from "@emotion/react";
var zoomOutDown = keyframes83(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));

// src/animations/zooming_exits/zoomOutLeft.ts
import { keyframes as keyframes84 } from "@emotion/react";
var zoomOutLeft = keyframes84(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0.1) translate3d(-2000px, 0, 0);\n  }\n"])));

// src/animations/zooming_exits/zoomOutRight.ts
import { keyframes as keyframes85 } from "@emotion/react";
var zoomOutRight = keyframes85(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0.1) translate3d(2000px, 0, 0);\n  }\n"])));

// src/animations/zooming_exits/zoomOutUp.ts
import { keyframes as keyframes86 } from "@emotion/react";
var zoomOutUp = keyframes86(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"])));

// src/components/Zoom.tsx
import { jsx as jsx11 } from "@emotion/react/jsx-runtime";
function getStyles8(reverse, direction) {
  switch (direction) {
    case "down":
      return reverse ? zoomOutDown : zoomInDown;
    case "left":
      return reverse ? zoomOutLeft : zoomInLeft;
    case "right":
      return reverse ? zoomOutRight : zoomInRight;
    case "up":
      return reverse ? zoomOutUp : zoomInUp;
    default:
      return reverse ? zoomOut : zoomIn;
  }
}
var Zoom = function Zoom(props) {
  var direction = props.direction,
    _props$reverse7 = props.reverse,
    reverse = _props$reverse7 === void 0 ? false : _props$reverse7,
    rest = _objectWithoutProperties(props, _excluded9);
  var keyframes87 = useMemo9(function () {
    return getStyles8(reverse, direction);
  }, [direction, reverse]);
  return /* @__PURE__ */jsx11(Reveal, _objectSpread({
    keyframes: keyframes87
  }, rest));
};
export { AttentionSeeker, Bounce, Fade, Flip, Hinge, JackInTheBox, Reveal, Roll, Rotate, Slide, Zoom, Reveal as default };